
import { PlayerDataService } from '../../services/player-data.service';
import { PlayerApiService } from '../../services/player-api.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'entry-decisions',
  standalone: true,
  imports: [
    CommonModule,   // ✅ Needed for built-in pipes like 'number', 'date', 'currency', etc.
    FormsModule

  ],
  templateUrl: './entry-decisions.component.html',
  styleUrl: './entry-decisions.component.css'
})
export class EntryDecisionsComponent implements OnInit {

  entryD: any = null;
  RO: any;
  maxProducts: number = 0;
  platformList: { platformId: number; platformName: string }[] = [];
  selectedPlatform: number | null = null;

  constructor(
    private playerData: PlayerDataService,
    private api: PlayerApiService
  ) { }

  async ngOnInit() {
    const cached = await this.playerData.getPageDecisionData('entry');
    this.entryD = cached || {
      CompanyName: '',
      Nooffact: 0,
      Product1Name: '',
      Product2Name: '',
      platformId1: 0,
      platformId2: 0


    };
    const roCached = await this.playerData.getPageDecisionData('readonly') || { "RoundSubUnit": "", "APARselectarr": "[]", "maxProducts": 0, "PlatformSelectvals": [] };
    this.RO = roCached;
    console.log(this.RO);
    this.platformList = this.RO.PlatformSelectvals;
    this.maxProducts = this.RO.maxProducts;
  }

  save() {
    // Touch dependent sections — backend may update linked data
    this.playerData.setPageDecisionData('entry', this.entryD);

    //  this.playerData.touchSectionsonEntry();

  }
}
